import { render, staticRenderFns } from "./ClientSideTable.vue?vue&type=template&id=2ca852a5&scoped=true"
import script from "./ClientSideTable.vue?vue&type=script&lang=js"
export * from "./ClientSideTable.vue?vue&type=script&lang=js"
import style0 from "./ClientSideTable.vue?vue&type=style&index=0&id=2ca852a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca852a5",
  null
  
)

export default component.exports